import { css } from 'lit';

export const styles = css `
  :host {
    display: flex;
    gap: 8px;
    align-items: center;
    flex-wrap: nowrap;
  }

  :host([alignment=start]) {
    justify-content: flex-start;
  }

  :host([alignment=center]) {
    justify-content: center;
  }

  :host([alignment=end]) {
    justify-content: flex-end;
  }
`;
